module.exports = __webpack_public_path__ + "img/stickers-avis-tiers-detenteur.d905af18.jpg";